import React from 'react';
import { Section } from '../ui/Section';
export function PainNarrative() {
  return <Section background="surface" data-id="element-59">
      <div className="max-w-2xl mx-auto space-y-6 text-lg leading-relaxed text-brand-parchment" data-id="element-60">
        <p className="font-serif text-2xl font-bold text-brand-cream" data-id="element-61">
          Every night it's the same story.
        </p>

        <p data-id="element-62">
          You're exhausted. Your eyes are heavy. You've had a long day of work,
          decisions, and stress. But the moment you turn off the lights, it
          starts.
        </p>

        <div className="border-l-4 border-brand-amber bg-brand-amber/5 p-6 rounded-r-lg my-8" data-id="element-63">
          <h3 className="text-brand-amber font-serif font-bold text-xl mb-2" data-id="element-64">
            The "Brain Loop"
          </h3>
          <p className="text-brand-parchment mb-0" data-id="element-65">
            A mental highlight reel of everything you didn't finish, every email
            you need to send, and every "what if" about your future. You try to
            pray it away, you try deep breathing, maybe you even take a
            Melatonin gummy.
          </p>
        </div>

        <p className="font-bold text-brand-cream text-xl" data-id="element-66">
          But 2:00 AM finds you staring at the ceiling again.
        </p>

        <p data-id="element-67">
          The truth is, you don't have a "sleep problem." You have a{' '}
          <strong className="text-brand-amber" data-id="element-68">
            Cortisol Clearance problem.
          </strong>
        </p>

        <p data-id="element-69">
          In the modern world, your body is bathed in blue light and high-stakes
          decisions until the minute you go to bed. This keeps your internal
          temperature high and your stress hormones spiked.
        </p>

        <p className="text-brand-cream font-medium" data-id="element-70">
          You are trying to sleep while your biology thinks you're running from
          a predator.
        </p>
      </div>
    </Section>;
}